import React from 'react';
import type { Product } from '../../types/product';
import { ProductCard } from './ProductCard';
import { LivingProductCard } from '../living/LivingProductCard';
export function ProductTile({
  product
}: {
  product: Product;
}) {
  return product.line === 'living' ? <LivingProductCard product={product} data-id="element-519" data-mp="3tyi1inqwozmn" /> : <ProductCard product={product} data-id="element-520" data-mp="3oy3un911jvq7" />;
}